'use client'

import { ThreadType } from '@/api/hooks/useThreads'
import { useAppDispatch } from '@/redux/hooks'
import { AssistantActions } from '@/redux/reducers/assistant'

import DataTable from '../data-table'
import { useThreadsTableColumns } from './columns'

type Props = {
  threads: ThreadType[]
}

const ThreadsTable = ({ threads }: Props) => {
  const columns = useThreadsTableColumns(threads)
  const dispatch = useAppDispatch()

  return (
    <DataTable
      canRenderExpandedRow={() => true}
      columns={columns}
      data={threads}
      getRowProps={row => ({
        className: 'cursor-pointer',
        onClick: () => {
          dispatch(AssistantActions.setActiveThreadId(row.id))
          dispatch(AssistantActions.toggleSideChat(true))
        },
      })}
    />
  )
}

export default ThreadsTable
